import React, {PureComponent} from "react"

import Flex from "@irati/ui/src/Flex"
import {H2, H6, Label} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedNumber, injectIntl, InjectIntl} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"

import {RouterLink} from "@irati/ui/src/Link"
import {Tooltip} from "@irati/ui/src/Tooltip"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {OrganisationalSummaryCategory} from "@irati/types"
import RadialPercentage from "../RadialPercentage"
import LinkToFAQ from "./LinkToFAQ"
import {FlexCard, CenteredSelf, CenteredFlex} from "./styled"

interface Props extends InjectIntl {
  trendRates: TrendRate[]
  hideEngagementRate: boolean
  selectedCategory: OrganisationalSummaryCategory
}

interface TrendRate {
  title: string
  description: string
  value: string
  linksToFAQ?: boolean
}

class TrendRates extends PureComponent<Props> {
  render() {
    const {trendRates = [], hideEngagementRate, selectedCategory, formatMessage} = this.props
    const rates = trendRates.filter((_trendRate: TrendRate, index) => index !== 0 || !hideEngagementRate)

    return (
      <CenteredFlex
        justifyContent="space-between"
        gap={theme.spacing.two}
        marginBottom={4}
        isSingleFlex={rates?.length === 1}
        id="adminSection_trendRatesSection">
        {rates.map((trendRate: TrendRate, index) => (
          <FlexCard padding={2}>
            <Flex justifyContent="space-between" direction="column" height="100%">
              <div>
                <CenteredSelf>
                  {index === 0 && !hideEngagementRate ? (
                    <RadialPercentage value={trendRate.value} small />
                  ) : (
                    <Flex gap={0.5}>
                      <H2 marginBottom>{parseInt(trendRate.value, 10) ? <FormattedNumber value={trendRate.value} /> : trendRate.value}</H2>
                      {trendRate?.tooltip && (
                        <Tooltip tooltipChildren={formatMessage({id: trendRate.tooltip})} placement="top">
                          <Icon marginLeft icon={IconTypes.info} size={24} />
                        </Tooltip>
                      )}
                    </Flex>
                  )}
                </CenteredSelf>
                <H6 marginBottom={1}>{formatMessage({id: trendRate.title})}</H6>
                <Label>
                  {formatMessage({id: trendRate.description})}
                  {trendRate?.linksToFAQ && <LinkToFAQ />}
                </Label>
              </div>
              {(selectedCategory === OrganisationalSummaryCategory.Main || selectedCategory === OrganisationalSummaryCategory.Perks) && (
                <Flex justifyContent="flex-end">
                  <RouterLink to="analytics/perks">
                    <FormattedMessage id="admin.reporting.orgSummary.trendRates.link" />
                  </RouterLink>
                </Flex>
              )}
            </Flex>
          </FlexCard>
        ))}
      </CenteredFlex>
    )
  }
}

export default injectIntl(TrendRates)
